// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/artwork-tile/artwork-tile.component.scss
// module id = 114
// module chunks = 0